export default __webpack_public_path__ + "static/media/1.b3453ee2.jpg";